import React from 'react';
import { ColumnsType } from 'antd/es/table';
import DetalleMetrica from './DetalleMetrica';

const DetalleDisponible: React.FC = () => {
  const columns: ColumnsType<any> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Nro. Fardo',
      dataIndex: 'nro_fardo',
      key: 'nro_fardo',
      width: 120,
      align: 'right' as const,
    },
    {
      title: 'Kilos Fardo',
      dataIndex: 'kilos_fardo',
      key: 'kilos_fardo',
      width: 120,
      align: 'right' as const,
      render: (value: number) => value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: 'Kilos Tara',
      dataIndex: 'kilos_tara',
      key: 'kilos_tara',
      width: 120,
      align: 'right' as const,
      render: (value: number) => value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: 'Kilos Neto',
      dataIndex: 'kilos_neto',
      key: 'kilos_neto',
      width: 120,
      align: 'right' as const,
      render: (value: number) => value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: 'Fecha/Hora',
      dataIndex: 'fecha_hora',
      key: 'fecha_hora',
      width: 160,
    },
    {
      title: 'Cliente',
      dataIndex: 'cliente',
      key: 'cliente',
      width: 200,
    },
    {
      title: 'Producto',
      dataIndex: 'producto',
      key: 'producto',
      width: 200,
    },
    {
      title: 'Nro. Producción',
      dataIndex: 'nro_produccion',
      key: 'nro_produccion',
      width: 150,
      align: 'right' as const,
    },
  ];

  const fetchData = async (idEmpresa: number, idProducto: number, token: string): Promise<any[]> => {
    // "Disponible" es un cálculo teórico (Stock + A Ingresar - A Salir)
    // Para el detalle, mostramos los fardos en stock (misma lógica que Stock)
    const url = `${process.env.REACT_APP_ESTADISTICAS_URL}/detalle/stock/${idEmpresa}/${idProducto}/`;
    
    console.log('DetalleDisponible - URL:', url);
    console.log('DetalleDisponible - idEmpresa:', idEmpresa, 'idProducto:', idProducto);
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Error desconocido' }));
        console.error('DetalleDisponible - Error response:', errorData);
        throw new Error(`Error al cargar datos: ${response.status} - ${JSON.stringify(errorData)}`);
      }

      const data = await response.json();
      console.log('DetalleDisponible - Datos recibidos:', data.length, 'registros');
      return data;
    } catch (error) {
      console.error('DetalleDisponible - Error en fetch:', error);
      throw error;
    }
  };

  return (
    <DetalleMetrica
      titulo="Detalle de Disponible"
      descripcion="Stock + A Ingresar - A Salir (fardos en stock actual)"
      fetchData={fetchData}
      columns={columns}
      nombreArchivo="disponible"
    />
  );
};

export default DetalleDisponible;

